// src/components/Footer.js
import React from 'react';

export default function Footer() {
  return (
    <footer style={styles.footer}>
      &copy; 2025 Share4IT Myanmar. All Rights Reserved.
    </footer>
  );
}

const styles = {
  footer: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: 'var(--card-bg)',
    color: 'var(--accent-color)',
    marginTop: 40,
    userSelect: 'none',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
  },
};
